import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box, keyframes, Tooltip } from '@mui/material'
import { AccessTime, CheckBox, Search, WatchLater } from '@mui/icons-material'
import ComboBoxHashtag from '../ComboBoxHashtag/ComboBoxHashtag'
import OneTextArea from '../../../Components/OneTextArea/OneTextArea'
import OneButton from '../../../Components/OneButton/OneButton'
import TratarEventoBl from './TratarEventoBl'
import { OneChatGPTComponente } from '../../../Components/OneChatGPT/ChatGPTComponente'

import {
    BtnLogEventoSx,
    GridBtnLogEventoSx,
    GridInfoEventosSx,
    GridInfoEventosValueSx,
    GridLogEventosSx,
    GridNumeroVersaoSx,
    InfoEventoTextAreaSx,
    LogEventoTextAreaSx
} from './TratarEventoSx'
import { formatDateTime } from '../../../Utils/Utils'

export const TratarEvento = ({ sx }) => {
    const {
        eventoSelecionado,
        hashtags,
        handleChangeHashtag,
        trataEventosDisabled,
        logsFechamento,
        handleClickLogEvento,
        gravarObservacao,
        handleMudarStatusEvento,
        disabledButtons,
        finalizarEvento,
        obsFechamento,
        setObsFechamento,
        handleObsGPT,
        valueHastag
    } = TratarEventoBl()

    const dataEvento = formatDateTime(eventoSelecionado.data)

    const campoEntrada = (evento) => {
        if (["OENE", "OENR"].includes(evento.evento)) {
            return evento.nome
        } else {
            return evento.entrada
        }
    }

    const blinkAnimation = keyframes`
    0% {
        border: 4px solid #ff7300
    }
    50% {
        border-color: #00000000
    }
    100% {
        border: 4px solid #ff7300
    }`

    return (
        <>
            <Grid container xl={5} lg={5} md={5} xs={6.5} sx={GridInfoEventosSx}>
                <Grid xs={12} sx={{ flexGrow: 0, flexBasis: 'auto' }}>
                    <Grid container xs={12}>
                        <Grid lg={2.5} md={4} xs={2.5}>Evento:</Grid>
                        <Grid lg={9.5} xs={8} sx={GridInfoEventosValueSx}>
                            <Box component='span' sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {eventoSelecionado.evento} - {eventoSelecionado.descricao}
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} >
                        <Grid lg={2.5} md={4} xs={2.5}>Cliente:</Grid>
                        <Grid lg={9.5} md={8} xs={9.5} sx={GridInfoEventosValueSx}>{eventoSelecionado.id_central} - {eventoSelecionado.condominio}</Grid>
                    </Grid>

                    <Grid container xs={12} >
                        <Grid lg={2.5} md={4} xs={2.5}>Entrada:</Grid>
                        <Grid lg={9.5} md={8} xs={9.5} sx={GridInfoEventosValueSx}>{campoEntrada(eventoSelecionado)}</Grid>
                    </Grid>

                    <Grid container xs={12} >
                        <Grid lg={2.5} md={4} xs={2.5}>Usuário:</Grid>
                        <Grid lg={9.5} md={8} xs={9.5} sx={GridInfoEventosValueSx}>{eventoSelecionado.usuario}</Grid>
                    </Grid>

                </Grid>

                {/* Procedimentos */}
                <Grid container xs={12} sx={{ flexGrow: 1, flexBasis: 'auto', marginTop: '3px' }}>
                    <Grid xs={3.5} sx={{ fontWeight: 700, height: '15px' }}>Procedimentos:</Grid>
                    <Grid container xs={8.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {eventoSelecionado.data &&
                            <Box compoment='span' id='dataEventoSelecionado' sx={{ fontSize: '12px', marginRight: '2px' }}>{dataEvento}</Box>
                        }
                        <WatchLater sx={{ fontSize: '14px', marginRight: '3px' }} />
                        <Box compoment='span' id='timerEventoSelecionado' sx={{ fontSize: '12px' }}></Box> {/* não excluir esse box */}
                    </Grid>
                    <OneTextArea
                        id='textarea-proc'
                        style={InfoEventoTextAreaSx}
                        textarea="true"
                        type="text"
                        value={eventoSelecionado?.procedimento}
                        autoScroll={true}
                        newSx={{ color: 'black', backgroundColor: '#c9c7c7' }}
                        readOnly
                    />
                </Grid>
            </Grid>

            {/* Sessao Log evento */}
            <Grid container xl={5} lg={5} md={7} sx={GridLogEventosSx}>
                <Grid container xs={12}>
                    <Grid xl={2} xs={3} sx={{ alignItems: 'center' }}>
                        <Grid>Tag Atend:</Grid>
                    </Grid>
                    <Grid xl={10} xs={9} sx={
                        valueHastag
                            ? { borderRadius: '10px', animation: `${blinkAnimation} 1s 4` }
                            : {}}
                    >
                        {hashtags.length > 0 &&
                            <ComboBoxHashtag onChange={handleChangeHashtag} options={hashtags} disabled={trataEventosDisabled()} />
                        }
                    </Grid>
                </Grid>

                <Grid container xs={12} sx={{ marginTop: '4px', flexGrow: 0, flexBasis: 'auto' }} >
                    <Grid xl={2} xs={1.5}>Log:</Grid>
                    <Grid xl={10} xs={10.5} sx={GridBtnLogEventoSx}>
                        {logsFechamento && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((el) => {
                            let infoBtn = logsFechamento.find(log => log.numero == el)
                            let disabled = trataEventosDisabled()
                            const tooltip_title = (infoBtn ? (infoBtn.titulo ? infoBtn.titulo : 'Sem descrição') : 'Não cadastrado')
                            return (
                                <Tooltip title={tooltip_title} arrow key={el}>
                                    <Box component={'span'} sx={{ ...BtnLogEventoSx, opacity: infoBtn && !disabled ? 1 : 0.4, cursor: infoBtn && !disabled ? 'pointer' : 'default' }} onClick={(!disabled ? () => { handleClickLogEvento(infoBtn) } : () => { })}>{el}</Box>
                                </Tooltip>
                            )
                        })
                        }
                    </Grid>
                </Grid>

                <Grid xs={12} sx={{ marginTop: '4px', flexGrow: 1, flexBasis: 'auto' }}>
                    <OneTextArea
                        id='input-obs'
                        style={LogEventoTextAreaSx}
                        textarea="true"
                        type={'text'}
                        value={obsFechamento}
                        onBlur={() => gravarObservacao()}
                        onChange={(e) => setObsFechamento(e.target.value)}
                        disabled={trataEventosDisabled()}
                        autoScroll={true}
                    />
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginRight: '3px'
                    }}>
                        <OneChatGPTComponente
                            value = { obsFechamento }
                            evento = { eventoSelecionado }
                            hashtags={hashtags}
                            mensagemGPT = {handleObsGPT}
                        />
                    </div>
                </Grid>

            </Grid>

            {/* Sessao opções evento */}
            <Grid container xl={2} lg={2} md={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: 0, margin: 0 }}>
                {/* <FormGroup>
            <OneCheckbox text='Notificar Supervisão' checked={notificacoes.supervisao} onChange={event => handleChangeNotificacoes(event, 'supervisao')} disabled={trataEventosDisabled()} />
            <OneCheckbox text='Notificar Gerência' checked={notificacoes.gerencia} onChange={event => handleChangeNotificacoes(event, 'gerencia')} disabled={trataEventosDisabled()} />
            <OneCheckbox text='Notificar Sindico' checked={notificacoes.sindico} onChange={event => handleChangeNotificacoes(event, 'sindico')} disabled={trataEventosDisabled()} />
        </FormGroup> */}

                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '4px' }}>
                    <OneButton variant="outlined" size="medium" color="one_secondary" IconStart={AccessTime} sxIconStart={{ width: '20px' }} onClick={() => handleMudarStatusEvento(3)} disabled={disabledButtons("espera")} ><span style={{ fontSize: '11px' }}>Em espera</span> </OneButton>
                    <OneButton variant="outlined" size="medium" color="one_secondary" IconStart={Search} sxIconStart={{ width: '20px' }} onClick={() => handleMudarStatusEvento(4)} disabled={disabledButtons("obs")} > <span style={{ fontSize: '11px' }}>Em observação</span> </OneButton>
                    <OneButton variant="outlined" size="large" color="one_secondary" IconStart={CheckBox} sxIconStart={{ width: '20px' }} onClick={finalizarEvento} disabled={trataEventosDisabled() || obsFechamento == ""}> <span style={{ fontSize: '13px' }}>Finalizar</span> </OneButton>
                </Box>
                <Grid sx={{ ...GridNumeroVersaoSx, fontSize: '10px', paddingTop: '7px' }} xl={12}>Desenvolvido por ONE</Grid>
            </Grid>
        </>
    )
}
